import toLower from 'lodash/toLower'
import get from 'lodash/get'

const parseParams = ({ params = {}, options = {} } = {}) => {
  return {
    value: get(params, 'value') || get(params, 'param') || ''
  }
}

export default (args) => {
  const { value } = parseParams(args)
  return toLower(value)
}

const humanizeCall = (args) => {
  return 'Lowercase Text'
}

export {
  humanizeCall
}
